import { styled } from "goober";
import { Icon } from "../Icon";
import { RefreshSpin } from "../RefreshSpin";
import { Tooltip } from "../Tooltip";
import { ControlButton } from "./ControlButton";

const IconButton = styled(ControlButton)`
  width: 24px;
  padding: 0;
  justify-content: center;
`;

export function RefreshButton({
  spinning,
  onClick,
}: {
  spinning: boolean;
  onClick: () => void;
}) {
  return (
    <Tooltip content="Refresh">
      <IconButton
        type="button"
        onClick={onClick}
        disabled={spinning}
        aria-label="Refresh"
      >
        <RefreshSpin spinning={spinning}>
          <Icon name="refresh-cw" size={12} color="var(--text-secondary)" />
        </RefreshSpin>
      </IconButton>
    </Tooltip>
  );
}
